// extracted by mini-css-extract-plugin
export var buttonHolder = "sideprojects-module--buttonHolder--3Zeb8";
export var heroAttribution = "sideprojects-module--heroAttribution--3IQHw";
export var line = "sideprojects-module--line--1CKUY";
export var promo = "sideprojects-module--promo--1PGep";